import { Check, X } from "lucide-react";

const RULES = [
  { test: (p) => p.length >= 8, label: "Minimo 8 caracteres" },
  { test: (p) => /[A-Z]/.test(p), label: "1 letra maiuscula" },
  { test: (p) => /[a-z]/.test(p), label: "1 letra minuscula" },
  { test: (p) => /[0-9]/.test(p), label: "1 numero" },
  { test: (p) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(p), label: "1 caractere especial (!@#$...)" },
];

export function isPasswordStrong(password) {
  return RULES.every((r) => r.test(password));
}

export default function PasswordStrength({ password }) {
  if (!password) return null;
  const passed = RULES.filter((r) => r.test(password)).length;
  const total = RULES.length;
  const pct = (passed / total) * 100;

  let color = "bg-rose-500";
  let label = "Fraca";
  if (pct >= 80) { color = "bg-emerald-500"; label = "Forte"; }
  else if (pct >= 60) { color = "bg-amber-500"; label = "Media"; }
  else if (pct >= 40) { color = "bg-orange-500"; label = "Fraca"; }

  return (
    <div data-testid="password-strength" className="mt-2 space-y-2">
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
          <div className={`h-full ${color} rounded-full transition-all duration-300`} style={{ width: `${pct}%` }} />
        </div>
        <span className={`text-[11px] font-semibold ${pct >= 80 ? "text-emerald-600" : pct >= 60 ? "text-amber-600" : "text-rose-600"}`}>
          {label}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-0.5">
        {RULES.map((r, i) => {
          const ok = r.test(password);
          return (
            <div key={i} className="flex items-center gap-1.5">
              {ok
                ? <Check className="w-3 h-3 text-emerald-500 flex-shrink-0" />
                : <X className="w-3 h-3 text-slate-300 flex-shrink-0" />
              }
              <span className={`text-[11px] ${ok ? "text-emerald-600" : "text-slate-400"}`}>{r.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
